import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=e9566d84&"
import script from "./BookDetails.vue?vue&type=script&lang=js&"
export * from "./BookDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports